<template>
  <v-container fluid>
    <el-overlay-loading :loading="pageloading" />
    <!-- title  -->
    <h1 class="mb-1">{{ $t(getTitle) }}</h1>
    <!-- form  -->
    <v-card outlined class="mb-4">
      <form @keydown.enter.prevent="submit()">
        <v-card-text class="mt-5">
          <v-row class="mb-0 pb-0">
            <v-col cols="12" md="12">
              <el-textarea
                label="Patartis"
                v-model="formData.title_lt"
                :disabled="modeReadonly"
                :maxlength="1000"
                required
              />
            </v-col>
            <v-col cols="12" md="12">
              <el-textarea
                required
                label="Patartis anglų kalba"
                v-model="formData.title_en"
                :disabled="modeReadonly"
                :maxlength="1000"
              />
            </v-col>
            <v-col cols="12" md="12">
               <el-text-field
                label="Kelias"
                disabled
                v-model="formData.code"
                :maxlength="1000"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-row no-gutters>
            <v-spacer></v-spacer>
            <el-button
              class="mr-1"
              color="secondary"
              icon="atšaukti"
              title="Atšaukti"
              @click.native.stop="back()"
              :loading="loading"
            />
            <el-button
              v-if="!modeReadonly"
              title="Išsaugoti"
              :loading="loading"
              @click.native="saveData()"
              color="primary"
              icon="išsaugoti"
            />
          </v-row>
        </v-card-actions>
      </form>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import userRole from '@/mixins/userRole'
import Enums from '@/enums'
export default {
  name: 'AdminErrorNotificationForm',

  mixins: [userRole],
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    return {
      pageloading: false,
      loading: false,
      formData: {},
      classifiers: [],
    }
  },
  computed: {
    modeReadonly() {
      return false
    },
    getId() {
      return this.$route.params.id || null
    },
    getTitle() {
      if (this.getId) {
        return this.$t(`Redaguoti patartį (angl. tooltip)`)
      } else {
        return this.$t(`Naujas patartis (angl. tooltip)`)
      }
    },
  },
  beforeDestroy() {},
  created() {
    if (this.getId) {
      this.getData()
    }
  },
  methods: {
    back() {
      this.$router.push({ name: 'classifierTooltips' })
    },
    getData() {
      this.pageloading = true

      this.$axios
        .get(`tooltips/${this.getId}`)
        .then((res) => {
          this.formData = res.data.tooltip
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.pageloading = false
        })
    },
    saveData() {
      this.$validator.validateAll().then((res) => {
        if (res) {
          this.loading = true
          let formData = this.formData
          let url = `tooltips`
          this.getId && (formData.id = this.getId)
          this.$axios
            .post(url, formData)
            .then((res) => {
              this.$root.$emit('DATA_OK_CODE', '000110')
              this.back()
            })
            .catch((err) => {
              this.$root.$emit('DATA_ERROR', err)
            })
            .finally(() => {
              this.loading = false
            })
        } else {
          this.$root.$emit('FORMAT_ERROR')
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped></style>
